import { PageTitle } from "@/lib/mui/PageTitle";
import { getTermsHtml } from "@/modules/static/getTermsHtml";
import { getWebsiteLayout } from "@/modules/navigation/website-layout/WebsiteLayout";
import Head from "next/head";
import React from "react";
import { appConfig } from "../config/app-config";
import { NextPageWithLayout } from "./_app";
import { PageLayout } from "@/modules/navigation/website-layout/PageLayout";

const Page: NextPageWithLayout<{ html: string }> = ({ html }) => {
  return (
    <>
      <Head>
        <title>Terms of Service – {appConfig.name}</title>
      </Head>

      <PageLayout>
        <PageTitle>Terms of Service</PageTitle>
        <article>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </article>
      </PageLayout>
    </>
  );
};

export async function getServerSideProps() {
  return {
    props: { html: await getTermsHtml() },
  };
}

Page.getLayout = getWebsiteLayout;

export default Page;
